import '/app/brewery-packages/content/content-editor-plugin-paragraph/src/Paragraph.css-raw';
export default {
  "paragraph": "cover-letter-traditional-173018a8-paragraph-WaWZGW"
};